export function compileInitHandler(
  initHandlerBody: string
): string {
  return `(outputs, state, params) => {
  ${initHandlerBody}
}`;
}
